import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import {IModalConfig, ModalService} from '../../services/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements AfterViewInit {
  isOpen: boolean;
  modalConfig: IModalConfig;

  constructor(
    private modalService: ModalService,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.modalConfig = this.defaultModalConfig;
    if (this.modalService.modalConfig) {
      this.modalConfig = {
        ...this.defaultModalConfig,
        ...this.modalService.modalConfig,
      };
    }

    this.isOpen = true;
    this.cdr.detectChanges();
  }

  @ViewChild('container', {static: false, read: ViewContainerRef}) set vcr(
    vcr: ViewContainerRef
  ) {
    if (!vcr || !this.isOpen) {
      return;
    }

    const componentRef: ComponentRef<unknown> = vcr.createComponent(
      this.modalService.factory
    );
  }

  close(): void {
    this.modalService.close();
  }

  private get defaultModalConfig(): IModalConfig {
    return {
      showClose: true,
      width: '50%',
    };
  }
}
